import { M_SQUARED_TO_KM_SQUARED } from "@/tools/create/lss-from-map/constants";

export const formatMetresSquaredAsKmSquared = (value: number, decimalPlaces = 6) => {
  return `${(value / M_SQUARED_TO_KM_SQUARED).toFixed(decimalPlaces)}km²`;
};
